<template>
  <div class="text-black">
    <div :class="['properties-search', mode]">
      <div>
        <p class="text-base mb-2" v-if="mode != 'horizontal'">
          Property Ref:
        </p>
        <input type="text" placeholder="Property Ref" v-model="search.ref_no" />
      </div>
      <div>
        <p class="text-base mb-2" v-if="mode != 'horizontal'">
          Property Type:
        </p>
        <v-select
          placeholder="Select a property type"
          label="fullName"
          :options="propertyTypes"
          :reduce="(field) => field.id"
          :multiple="true"
          v-model="search.property_type_id"
        />
      </div>
      <div>
        <p class="text-base mb-2" v-if="mode != 'horizontal'">
          Locality:
        </p>
        <v-select
          placeholder="Select a locality"
          label="name"
          :options="cities(128)"
          :reduce="(field) => field.id"
          :multiple="true"
          v-model="search.city_id"
        />
      </div>
      <div v-if="mode != 'horizontal'">
        <p class="text-base mb-4">
          Price Range:
        </p>
        <PriceRangeSlider
          v-if="mode != 'horizontal'"
          :mode="mode"
          v-model="search.price"
        />
      </div>
      <div v-if="mode != 'horizontal'">
        <div class="grid grid-cols-2 gap-x-4">
          <div>
            <p class="text-base mb-2">Bedrooms:</p>
            <input
              type="number"
              placeholder="Bedrooms"
              v-model.number="search.bedrooms"
            />
          </div>
          <div>
            <p class="text-base mb-2">Bathrooms:</p>
            <input
              type="number"
              placeholder="Bathrooms"
              v-model.number="search.main_bathrooms"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="absolute left-0 top-full w-full mt-20 md:mt-12 p-8 bg-white rounded-lg transition duration-500"
      v-bind:class="[
        mode == 'horizontal' && expanded ? 'opacity-100' : 'opacity-0',
      ]"
    >
      <p class="text-lg mb-8 text-center font-bold">
        Make the search more accurate
      </p>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div class="col-span-2">
          <PriceRangeSlider
            v-if="mode == 'horizontal'"
            :mode="mode"
            v-model="search.price"
          />
        </div>
        <div>
          <input
            type="number"
            placeholder="Bedrooms"
            v-model.number="search.bedrooms"
          />
        </div>
        <div>
          <input
            type="number"
            placeholder="Bathrooms"
            v-model.number="search.main_bathrooms"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { PriceRangeSlider } from "@/components/atoms";

export default {
  props: {
    mode: {
      type: String,
      default: "vertical",
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PriceRangeSlider,
  },
  mounted: function() {
    this.search = {
      ref_no: this.$route.query.ref_no || "",
      property_type_id:
        (this.$route.query.property_types &&
          this.$route.query.property_types.split(",").map((x) => {
            return parseInt(x);
          })) ||
        [],
      city_id:
        (this.$route.query.cities &&
          this.$route.query.cities.split(",").map((x) => {
            return parseInt(x);
          })) ||
        [],
      price:
        (this.$route.query.price &&
          this.$route.query.price.split(",").map((x) => {
            return parseInt(x);
          })) ||
        [],
      bedrooms: this.$route.query.bedrooms,
      main_bathrooms: this.$route.query.main_bathrooms,
    };
  },
  data: function() {
    return {
      search: {
        ref_no: "",
        property_type_id: [],
        city_id: [],
        price: [450, 5000],
        bedrooms: undefined,
        main_bathrooms: undefined,
      },
    };
  },
  watch: {
    search: {
      deep: true,
      handler() {
        var tempSearch = {};

        if (this.search.ref_no && this.search.ref_no.trim() != "") {
          tempSearch.ref_no = this.search.ref_no.trim();
        }
        if (this.search.property_type_id.length) {
          tempSearch.property_type_id = this.search.property_type_id;
        }
        if (this.search.city_id.length) {
          tempSearch.city_id = this.search.city_id;
        }
        if (this.search.price && this.search.price.length) {
          tempSearch.price = {
            operator: "between",
            value: this.search.price,
          };
        }
        if (this.search.bedrooms) {
          tempSearch.bedrooms = this.search.bedrooms;
        }
        if (this.search.main_bathrooms) {
          tempSearch.main_bathrooms = this.search.main_bathrooms;
        }

        this.$emit("input", tempSearch);
      },
    },
  },
  computed: {
    ...mapGetters("Generic", {
      cities: "cities",
    }),
    ...mapGetters("Properties", {
      propertyTypes: "propertyTypes",
    }),
  },
  methods: {
    ...mapActions("Generic", {
      getCities: "getCities",
    }),
    ...mapActions("Properties", {
      getPropertyTypes: "getPropertyTypes",
    }),
  },
  beforeMount: function() {
    this.getPropertyTypes();
    this.getCities(128);
  },
};
</script>

<style lang="scss" scoped>
.properties-search {
  @apply text-black;

  &.vertical {
    @apply flex flex-col;

    & > div {
      @apply mb-6;
    }
  }
  &.horizontal {
    @apply grid grid-cols-1 gap-6;

    @screen md {
      @apply grid-cols-3;
    }

    & > div {
      flex-grow: 1;
    }
  }
}
</style>
